// @ts-strict-ignore
import { customHeaders, requestApi } from 'api/api'
import {
  ForgotPasswordReq,
  ForgotPasswordResponse,
  ResetPasswordReq,
  ResetPasswordResponse,
} from 'types/passwords'

export const postForgotPassword = async ({
  emailAddress,
  recaptcha,
  recaptchaVersion,
  fingerprintEventId,
}: ForgotPasswordReq): Promise<ForgotPasswordResponse> => {
  return requestApi({
    url: `/user/forgot/request`,
    method: 'POST',
    data: { emailAddress, recaptcha, recaptchaVersion },
    authenticated: false,
    headers: fingerprintEventId
      ? { ...customHeaders, 'X-Fingerprint-Event-Id': fingerprintEventId }
      : customHeaders,
  })
}

export const postResetPassword = async ({
  newPassword,
  token,
  recaptcha,
  recaptchaVersion,
  fingerprintEventId,
}: ResetPasswordReq): Promise<ResetPasswordResponse> => {
  return requestApi({
    url: '/user/forgot/confirm',
    method: 'POST',
    data: { newPassword, token, recaptcha, recaptchaVersion },
    authenticated: false,
    headers: fingerprintEventId
      ? { ...customHeaders, 'X-Fingerprint-Event-Id': fingerprintEventId }
      : customHeaders,
  })
}
